import axios from "../api/api";

const fetchOrder = async () => {
  const response = await axios.get("/order", {
    headers: {
      "Content-Type": "text/plain",
      Accept: "application/json, text/plain, */*",
    },
  });

  return response;
};

export default fetchOrder;
